module.exports = __webpack_public_path__ + "static/media/theoryQ2_2.480b56c8.mp4";